import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import myFooter from './layout/footer.vue'
// import myHeader from './layout/header.vue'

import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'

import VueRouter from 'vue-router'
// 全局注册 MyComponent
Vue.component('myFooter', myFooter);
// Vue.component('myHeader', myHeader);
 

Vue.use(ElementUI).use(VueRouter)
Vue.config.productionTip = false

// 注册全局滚动动画指令
Vue.directive('scroll-animation', {
  mounted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('animate__animated', 'animate__fadeInUp')
          observer.unobserve(el)
        }
      })
    }, {
      threshold: 0.1
    })
    observer.observe(el)
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


